import { Option as SelectOption } from '@superhi/design/src/components/forms/inputs/SelectInput/SelectInput'

import { API } from 'src/api'

const TYPE_LANGUAGE: Record<API.HallOfFamerType, string> = {
  WEBSITE: 'Website',
  DESIGN: 'Design',
}

export const TYPE_OPTIONS: SelectOption<API.HallOfFamerType | undefined>[] = [
  { display: 'Any type', value: undefined },
  ...Object.values(API.HallOfFamerType).map((type) => ({
    display: TYPE_LANGUAGE[type],
    value: type,
  })),
]
